<template>
    <div
        class="login-bg"
        v-loading="isLoading"
        element-loading-text="登录中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div
            class="login-container"
            :class="{ 'login-container_register': isRegisterMode }"
        >
            <img src="~@/assets/img/login_logo.png" class="login-logo" />
            <div
                v-if="!isRegisterMode && !isShowChooseCo"
                :class="!isScanMode ? 'scan-mode' : 'input-mode'"
                class="login-method"
                @click="toggleLoginAndScanMode"
            />
            <div class="login-form">
                <ScanCodeForm
                    v-if="isScanMode"
                    @handleShowPrivacy="handleShowPrivacyModal"
                />
                <LoginForm
                    v-if="isLoginMode"
                    @handleLogin="isLoading = true"
                    @loginFail="isLoading = false"
                    @handleShowPrivacy="handleShowPrivacyModal"
                    @handleRegister="toggleLoginAndRegister"
                    @showChooseCompany="showChooseCompany"
                />
                <RegisterForm
                    v-if="isRegisterMode"
                    @handleGoLogin="toggleLoginAndRegister"
                    @handleShowPrivacy="handleShowPrivacyModal"
                />
                <ChooseCompany
                    v-if="isChooseCoMode"
                    v-show="isShowChooseCo"
                    @loginSuccess="isLoading = false"
                    :tenant-list="userCompanyList"
                    ref="chooseCompanyRef"
                />
            </div>
        </div>
        <div class="login-mark" @click="handleClickMark">沪ICP备18041913号-2</div>
        <LoginNavBar class="login-nav" />
        <PrivacyAgreementModal
            :visible="visibleModal"
            @handleCloseModal="visibleModal = false"
        ></PrivacyAgreementModal>
    </div>
</template>

<script>
import LoginForm from '@/views/login/components/LoginForm'
import ScanCodeForm from '@/views/login/components/ScanCodeForm'
import PrivacyAgreementModal from '@/views/login/components/PrivacyAgreementModal'
import RegisterForm from '@/views/login/components/RegisterForm'
import ChooseCompany from '@/views/login/components/ChooseCompany'
import { bindUserEmail, checkCoSof, getMyUserInfo, loginUserByWechat } from '@/api/user'
import LoginNavBar from './components/LoginNavBar'
import { decryptRSA } from '@/utils/RSA'
import { Message } from 'element-ui'
import { storageGet, storageSet } from '@/utils'
import { storageKey } from '@/utils/config'
import { getCompanyList } from '@/api/login'

export default {
    name: 'Login',
    components: {
        LoginNavBar,
        ChooseCompany,
        RegisterForm,
        PrivacyAgreementModal,
        ScanCodeForm,
        LoginForm,
    },
    data () {
        return {
            isLoginMode: true,
            isScanMode: false,
            isRegisterMode: false,
            isChooseCoMode: false,
            isShowChooseCo: false,
            isLoading: false,
            visibleModal: false,
            userCompanyList: [],
        }
    },
    methods: {
        handleShowPrivacyModal () {
            this.visibleModal = true
        },
        toggleLoginAndRegister () {
            this.isLoginMode = !this.isLoginMode
            this.isRegisterMode = !this.isRegisterMode
        },
        showChooseCompany (data) {
            // 当有个人版企业版的时候才会隐藏登录显示选择企业
            // 只有个人版默认还是会渲染选择企业组件调用组件内的登录方法 但隐藏在页面内
            // if (data.length > 1) {
                this.isLoginMode = false
                this.isShowChooseCo = true
                this.isLoading = false
            // }
            // 把个人版排到最后一个选项
            this.userCompanyList = data.sort((a, b) => (b.coId === 165 ? -1 : 1))
            this.isChooseCoMode = true
        },
        toggleLoginAndScanMode () {
            this.isScanMode = !this.isScanMode
            this.isLoginMode = !this.isLoginMode
        },
        async loginByWechat (code) {
            this.isLoading = true
            const SIGN_SOF_ID = [11, 95]
            const { success, usrId, phone, cos } = await loginUserByWechat(
                code,
                SIGN_SOF_ID
            )
            if (success && usrId) {
                await this.$store.commit('setUserId', usrId)
                await this.$store.commit('setUserPhone', phone)
                await this.$store.commit('setUserAccount', phone)
                this.showChooseCompany(cos)
            } else {
                this.$message.error('微信登录失败，请重试')
                this.isLoading = false
            }
        },
        async checkBindEmail (emailCode) {
            if (emailCode) {
                const { success } = await bindUserEmail(emailCode)
                success
                    ? this.$message.success('邮箱认证成功')
                    : this.$message.error('邮箱认证失败')
            }
        },
        handleClickMark () {
            window.location.href = 'https://beian.miit.gov.cn'
        },
        async checkCoSof () {
            const { success, realName, token } = await checkCoSof()
            if (success) {
                await this.$store.commit('setToken', token)
                await this.$store.commit('setUserName', realName)
            }
        },
    },
    async created () {
        this.$store.commit('logoutUser')
        const { code, ActivationEmailCode, token, tenantId, coId } = this.$route.query
        if (code) {
            return this.loginByWechat(code)
        }
        if (ActivationEmailCode) {
            return this.checkBindEmail(ActivationEmailCode)
        }
        if (token && tenantId && coId) {
            try {
                // const obj = JSON.parse(decryptRSA(token))
                // if (!obj) return
                this.isLoading = true
                localStorage.clear()
                await this.$store.commit('setcoId', coId)
                await this.$store.commit('setToken', token)
                await this.$store.commit('setSofId', '95')
                const res = await getMyUserInfo();
                if (!res.userId) {
                    Message.error("用户不存在");
                    this.isLoading = false;
                    return
                }
                storageSet(storageKey.user, res)
                await this.$store.commit('setUserId', res.userId)
                await this.$store.commit('setUserPhone', res.mobile)
                await this.$store.commit('setUserAccount', res.username)
                await this.$store.commit('setUserName', `${res.fname}${res.lname}`)


                const tenant = res.tenantInfoList.find((item) => `${item.id}` === `${tenantId}`);
                if (!tenant) {
                    Message.error("租户不存在");
                    this.isLoading = false;
                    return
                }

                storageSet(storageKey.tenant, tenant);

                const companyList = await getCompanyList()
                const company = companyList.find((item) => `${item.id}` === `${coId}`);
                if (!company) {
                    Message.error("公司不存在");
                    this.isLoading = false;
                    return
                }
                storageSet(storageKey.company, company);

                storageSet("login-company-id", company.id);
                storageSet("login-tenant-id", tenant.id);
                this.isLoading = false
                this.$router.replace('/')
            } catch (e) {
                this.isLoading = false
            }
        }
    },
}
</script>

<style scoped lang="scss">
.login {
    &-bg {
        background-image: url("../../assets/img/login_bg.png");
        background-size: cover;
        height: 100%;
        width: 100%;
        @include flex-box(center, center);
    }

    &-container {
        height: 520px;
        position: relative;
        border-radius: 14px;
        background: #ffffff;
        box-shadow: 5px 5px 25px 0 rgba(0, 0, 0, 0.5);
        padding: 0 60px 0 72px;
        @include flex-box(space-between, center);

        &_register {
            padding: 34px 60px 34px 72px;
        }
    }

    &-method {
        width: 77px;
        height: 76px;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
    }

    &-logo {
        height: auto;
    }

    &-nav {
        position: absolute;
        top: 0;
        left: 0;
    }

    &-form {
        width: 370px;
        margin-left: 104px;
        height: 100%;
        @include flex-box(flex-start, center);
    }

    &-mark {
        font-weight: 550;
        color: #ffffff;
        opacity: 0.3;
        position: absolute;
        right: 40px;
        bottom: 40px;
        cursor: pointer;
    }
}

.scan-mode,
.input-mode {
    background-size: 100%;
}

.scan-mode {
    background-image: url("~@/assets/img/scan_mode.png");
}

.scan-mode:hover {
    background-image: url("~@/assets/img/scan_mode_hover.png");
}

.input-mode {
    background-image: url("~@/assets/img/input_mode.png");
}

.input-mode:hover {
    background-image: url("~@/assets/img/input_mode_hover.png");
}

@media screen and (max-width: 1280px) {
    .login-logo_top {
        top: 8px;
        left: 8px;
    }
}

::v-deep(.el-tabs__header) {
    margin: 0 0 39px;
}

::v-deep(.el-tabs__item) {
    font-family: $font-weight-5;
    padding: 0;
    font-size: 18px;
    height: 55px;
    line-height: 55px;
}

::v-deep(.el-input__prefix) {
    height: auto;
    line-height: 43px;
    vertical-align: middle;
    left: 10px;
}

::v-deep(.el-input__suffix) {
    right: 10px;
}

::v-deep(.el-checkbox__label) {
    font-size: 12px;
    color: #666666;
}

::v-deep(.el-input--prefix .el-input__inner) {
    height: 46px;
    line-height: 46px;
    padding-left: 42px;
}

::v-deep(.el-form-item--small.el-form-item) {
    margin-bottom: 0;
}

::v-deep(.el-form-item--small .el-form-item__error) {
    margin-top: 8px;
}

::v-deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
    color: $color-666;
}
</style>
